<template>
    <DemoAccountDataTable></DemoAccountDataTable>
</template>

<script>
import DemoAccountDataTable from "./DemoAccountDataTable.vue";

export default {
    components: { DemoAccountDataTable },
}
</script>